var defaultSetup = function () {
  return {
    crafting: [
      {
        enabled: true,
        size: 3,
        goals: [
          "item.minecraft.bucket"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_ingot",
          "item.minecraft.diamond",
          "block.minecraft.dirt",
          "item.minecraft.wheat",
          "item.minecraft.carrot"
        ],
        weight: 1
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "item.minecraft.bread"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_ingot",
          "item.minecraft.diamond",
          "block.minecraft.dirt",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
          "item.minecraft.iron_nugget",
          "item.minecraft.gold_nugget"
        ],
        weight: 1
      },
      {
        enabled: true,
        size: 2,
        goals: [
          "item.minecraft.flint_and_steel"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_ingot",
          "item.minecraft.flint",
          "block.minecraft.dirt",
          "block.minecraft.gravel",
          "block.minecraft.cobblestone"
        ],
        weight: 1.2
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_ingot"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_ingot",
          "item.minecraft.diamond",
          "block.minecraft.dirt",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
          "item.minecraft.iron_nugget",
          "item.minecraft.gold_nugget"
        ],
        weight: 1.7
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "item.minecraft.iron_pickaxe"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.white_wool",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "block.minecraft.glowstone",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "block.minecraft.gravel",
          "block.minecraft.dirt",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.blaze_powder",
          "item.minecraft.stick",
          "block.minecraft.nether_bricks"
        ],
        weight: 1.3
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "item.minecraft.iron_axe"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.white_wool",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "block.minecraft.glowstone",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "block.minecraft.gravel",
          "block.minecraft.dirt",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.blaze_powder",
          "item.minecraft.stick",
          "item.minecraft.string",
          "item.minecraft.iron_nugget",
          "block.minecraft.nether_bricks"
        ],
        weight: 1
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "item.minecraft.iron_sword"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.white_wool",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "block.minecraft.glowstone",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "block.minecraft.gravel",
          "block.minecraft.dirt",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.blaze_powder",
          "item.minecraft.stick",
          "item.minecraft.string",
          "item.minecraft.iron_nugget",
          "item.minecraft.nether_brick",
          "item.minecraft.diamond",
          "block.minecraft.nether_bricks"
        ],
        weight: 1.1
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "item.minecraft.golden_carrot"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "item.minecraft.gold_nugget",
          "item.minecraft.carrot",
          "item.minecraft.nether_brick",
          "item.minecraft.stick",
          "block.minecraft.gravel",
          "item.minecraft.string",
          "block.minecraft.white_wool",
          "block.minecraft.soul_sand",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.glowstone_dust",
          "block.minecraft.dirt",
          "item.minecraft.magma_cream",
          "item.minecraft.quartz"
        ],
        weight: 0.7
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "block.minecraft.white_bed"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.white_wool",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "block.minecraft.glowstone",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "block.minecraft.gravel",
          "block.minecraft.dirt",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.blaze_powder",
          "item.minecraft.stick",
          "item.minecraft.string",
          "item.minecraft.iron_nugget",
          "block.minecraft.nether_bricks"
        ],
        weight: 2
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "block.minecraft.respawn_anchor"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.white_wool",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "block.minecraft.glowstone",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "block.minecraft.gravel",
          "block.minecraft.dirt",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.blaze_powder",
          "item.minecraft.stick",
          "item.minecraft.string",
          "item.minecraft.iron_nugget",
          "block.minecraft.nether_bricks",
          "block.minecraft.blackstone"
        ],
        weight: 2
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "item.minecraft.bow"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "block.minecraft.glowstone",
          "item.minecraft.ender_pearl",
          "block.minecraft.gravel",
          "block.minecraft.dirt",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.blaze_powder",
          "item.minecraft.stick",
          "item.minecraft.string",
          "block.minecraft.nether_bricks",
          "block.minecraft.white_wool",
          "item.minecraft.leather"
        ],
        weight: 2
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "item.minecraft.golden_pickaxe"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.white_wool",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "block.minecraft.glowstone",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "block.minecraft.gravel",
          "block.minecraft.dirt",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.blaze_powder",
          "item.minecraft.stick",
          "block.minecraft.nether_bricks"
        ],
        weight: 2
      },
      {
        enabled: true,
        size: 3,
        goals: [
          "item.minecraft.golden_apple"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "item.minecraft.gold_nugget",
          "item.minecraft.carrot",
          "item.minecraft.nether_brick",
          "item.minecraft.stick",
          "block.minecraft.gravel",
          "item.minecraft.string",
          "block.minecraft.white_wool",
          "block.minecraft.soul_sand",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.glowstone_dust",
          "block.minecraft.dirt",
          "item.minecraft.apple"
        ],
        weight: 0.5
      },
      {
        enabled: true,
        size: 2,
        goals: [
          "block.minecraft.nether_bricks"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "item.minecraft.gold_nugget",
          "item.minecraft.carrot",
          "item.minecraft.nether_brick",
          "item.minecraft.stick",
          "block.minecraft.gravel",
          "item.minecraft.string",
          "block.minecraft.soul_sand",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.glowstone_dust",
          "block.minecraft.dirt"
        ],
        weight: 1.2
      },
      {
        enabled: true,
        size: 2,
        goals: [
          "block.minecraft.white_wool"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "item.minecraft.gold_nugget",
          "item.minecraft.carrot",
          "item.minecraft.nether_brick",
          "item.minecraft.stick",
          "block.minecraft.gravel",
          "item.minecraft.string",
          "block.minecraft.soul_sand",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.glowstone_dust",
          "block.minecraft.dirt",
          "block.minecraft.white_wool"
        ],
        weight: 1.2
      },
      {
        enabled: true,
        size: 2,
        goals: [
          "block.minecraft.glowstone"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "item.minecraft.gold_nugget",
          "item.minecraft.carrot",
          "item.minecraft.nether_brick",
          "item.minecraft.stick",
          "block.minecraft.gravel",
          "item.minecraft.string",
          "block.minecraft.white_wool",
          "block.minecraft.soul_sand",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.glowstone_dust",
          "block.minecraft.dirt",
          "block.minecraft.nether_bricks"
        ],
        weight: 1.2
      },
      {
        enabled: true,
        size: 2,
        goals: [
          "item.minecraft.stick"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.white_wool",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "block.minecraft.glowstone",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "block.minecraft.gravel",
          "block.minecraft.dirt",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.blaze_powder",
          "item.minecraft.stick",
          "item.minecraft.string",
          "item.minecraft.iron_nugget",
          "block.minecraft.nether_bricks"
        ],
        weight: 1.2
      },
      {
        enabled: true,
        size: 2,
        goals: [
          "item.minecraft.ender_eye",
          "item.minecraft.blaze_powder"
        ],
        inventory: [
          "block.minecraft.oak_planks",
          "block.minecraft.white_wool",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "block.minecraft.glowstone",
          "item.minecraft.ender_pearl",
          "item.minecraft.blaze_rod",
          "block.minecraft.gravel",
          "block.minecraft.dirt",
          "item.minecraft.gold_ingot",
          "item.minecraft.iron_ingot",
          "item.minecraft.blaze_powder",
          "item.minecraft.stick",
          "item.minecraft.string",
          "item.minecraft.iron_nugget",
          "block.minecraft.nether_bricks"
        ],
        weight: 1.8
      }
    ],
    options: {
      max_characters: 3,
      score_search_lengths: true,
      optimize_unique_characters: true,
      search: "",
      auto_search: false,
      letter_penalty: "10",
      junk_penalty: "15",
      has_junk_penalty: "40",
      fail_penalty: "1000",
      allow_permitted_items: false,
      permit_goal_items: false,
      permitted_items_benefit: "0",
      permitted_items: [],
      overlap_crafting: true,
      overlap_penalty: "0",
      resource_id: true,
      double_input: 1,
      character_blacklist: ""
    },
    enabled_languages: [
      "so_so",
      "af_za",
      "esan"
    ],
    disabled_languages: [
      "lzh",
      "ja_jp",
      "ko_kr",
      "zh_cn",
      "zh_hk",
      "zh_tw",
      "fa_ir",
      "ar_sa"
    ]
  }
}

export const DefaultSetup = defaultSetup;
